import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import api from "src/services/api";
import LoadingButton from "../LoadingButton";
import { Button } from "../ui/button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

function DynamicList({ listName, listConfig, control, register, errors }) {
  const { fields, append } = useFieldArray({
    control,
    name: listName,
  });

  return (
    <div className="border p-3 rounded">
      <label className="font-medium text-sm mr-6">
        {listName.charAt(0).toUpperCase() + listName.slice(1)}:
      </label>
      {fields.map((item, index) => (
        <div key={item.id} className="flex flex-wrap gap-3 mt-2">
          {listConfig.fields.map((field) => (
            <div key={field} className="w-full">
              <input
                key={field}
                type={
                  field.toLowerCase() === "data"
                    ? "date"
                    : field.toLowerCase() === "hora"
                    ? "time"
                    : "text"
                }
                {...register(`${listName}.${index}.${field}`, {
                  required: "Este campo é obrigatório",
                })}
                className="border rounded p-2 w-full"
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
              />
              {errors[listName]?.[index]?.[field] && (
                <span className="text-red-500 text-sm block mt-1">
                  {errors[listName]?.[index]?.[field].message}
                </span>
              )}
            </div>
          ))}
        </div>
      ))}
      <Button
        type="button"
        onClick={() => append({})}
        className="mt-2 bg-blue-500 hover:bg-blue-600 text-white"
      >
        Adicionar {listName}
      </Button>
    </div>
  );
}

export default function TemplateDocumentos() {
  const [loading, setLoading] = useState({
    select: false,
    send: false,
  });
  const [projects, setProjects] = useState({
    projects: [],
    selectedProject: "",
  });
  const [templates, setTemplates] = useState({
    templates: [],
    selectedTemplate: "",
  });
  const [schema, setSchema] = useState(null);
  const history = useHistory();
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const projectsChange = (projectId) => {
    const selected = projects.projects.find((p) => p.id === projectId);
    setProjects((prevState) => ({
      ...prevState,
      selectedProject: selected ? { id: selected.id, name: selected.name } : "",
    }));
  };

  const templatesChange = (value) => {
    setTemplates((prevState) => ({
      ...prevState,
      selectedTemplate: value,
    }));
  };

  const fetchTemplate = async () => {
    if (!templates.selectedTemplate) return;
    setLoading((prev) => ({ ...prev, select: true }));

    try {
      const response = await api.get(`/template/${templates.selectedTemplate}`);
      setSchema(response.data.schema);

      reset({});
    } catch (error) {
      console.error("Erro ao buscar template!", error);
    } finally {
      setLoading((prev) => ({ ...prev, select: false }));
    }
  };

  useEffect(() => {
    const fetchTemplatesList = async () => {
      try {
        const response = await api.get("/template");
        setTemplates((prev) => ({
          ...prev,
          templates: response.data.templates,
        }));
      } catch (error) {
        console.error("Erro ao buscar templates!", error);
      }
    };
    const fetchProjectsList = async () => {
      try {
        const token = localStorage.getItem("auth-token");
        const response = await api.get("/projectsUser", {
          headers: { "x-auth-token": token },
        });
        setProjects((prev) => ({
          ...prev,
          projects: response.data,
        }));
      } catch (error) {
        console.error("Erro ao buscar projetos!", error);
      }
    };

    fetchTemplatesList();
    fetchProjectsList();
  }, []);

  const onSubmit = async (formData) => {
    setLoading((prev) => ({ ...prev, send: true }));

    try {
      const date = new Date();
      const formattedDate =
        date.getFullYear().toString().slice(-2) +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0");

      const documentData = {
        title: `${templates.selectedTemplate}_${formattedDate}`,
        template: templates.selectedTemplate,
        projeto: {
          nome: projects.selectedProject.name,
          id: projects.selectedProject.id,
        },
        fields: formData,
      };

      const token = localStorage.getItem("auth-token");

      await api.post("/documentos", documentData, {
        headers: { "x-auth-token": token },
      });

      alert("Documento enviado com sucesso!");
      history.push("/documentos-ata");
    } catch (error) {
      console.error("Erro ao enviar documento!", error);
      alert(
        `Erro ao enviar documento! ${
          error.response?.data?.error || error.message
        }`
      );
    } finally {
      setLoading((prev) => ({ ...prev, send: false }));
    }
  };

  return (
    <div className={"flex flex-col items-center justify-center"}>
      <>
        <nav
          className="navigation"
          style={{
            marginTop: "100px",
          }}
        >
          <ul>
            <li>
              <a href="/perfil">Home</a>
            </li>
            <li>/</li>
            <li>
              <a href="/documentos-ata">Documentos</a>
            </li>
            <li>/</li>
            <li>
              <a href="/produtividade/#">Modelos</a>
            </li>
          </ul>
        </nav>
        <div
          style={{
            width: "95%",
            display: "flex",
            justifyContent: "center",
            borderBottom: "2px solid #006998",
            marginBottom: "3rem",
          }}
        >
          <p
            className="relatorio-title"
            style={{
              fontSize: "35px",
              fontWeight: "700",
              color: "#00293B",
              fontFamily: "satoshi",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          >
            Documentos
          </p>
        </div>
      </>

      <div className="w-[95%]">
        <p className="filter-title">Selecione o modelo do documento:</p>
        <div className="gap-3 p-3 flex">
          <Select onValueChange={templatesChange}>
            <SelectTrigger className="w-52">
              <SelectValue placeholder="Modelo" />
            </SelectTrigger>
            <SelectContent position="item-aligned">
              <SelectGroup>
                {templates.templates.map((template) => (
                  <SelectItem key={template.name} value={template.name}>
                    {template.name}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>

          <Select onValueChange={projectsChange}>
            <SelectTrigger className="w-52">
              <SelectValue placeholder="Projeto" />
            </SelectTrigger>
            <SelectContent position="item-aligned">
              <SelectGroup>
                {projects.projects.map((project) => (
                  <SelectItem key={project.id} value={project.id}>
                    {project.name}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>

          <LoadingButton
            loading={loading.select}
            disabled={!templates.selectedTemplate || !projects.selectedProject}
            onClick={fetchTemplate}
            className="bg-gray-800 hover:bg-gray-700 text-white"
          >
            Selecionar
          </LoadingButton>
        </div>

        {schema && (
          <form onSubmit={handleSubmit(onSubmit)} className="mt-6 space-y-4">
            {/* Renderiza os campos simples */}
            {schema.fields.map((field) => (
              <div key={field} className="flex flex-col">
                <label className="font-medium text-sm">
                  {field.charAt(0).toUpperCase() + field.slice(1)}:
                </label>
                <input
                  type={
                    field.toLowerCase() === "data"
                      ? "date"
                      : field.toLowerCase() === "hora"
                      ? "time"
                      : "text"
                  }
                  {...register(field, { required: "Este campo é obrigatório" })}
                  className="border rounded p-2 w-full"
                  placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                />
                {errors[field] && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors[field].message}
                  </span>
                )}
              </div>
            ))}

            {/* Renderiza as listas dinâmicas */}
            {Object.entries(schema.lists).map(([listName, listConfig]) => (
              <DynamicList
                key={listName}
                listName={listName}
                listConfig={listConfig}
                control={control}
                register={register}
                errors={errors}
              />
            ))}

            <div className="flex justify-center">
              <LoadingButton
                type="submit"
                loading={loading.send}
                className="my-4 bg-green-600 hover:bg-green-700 text-white px-8"
              >
                Enviar
              </LoadingButton>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
